import React from "react";

const LEVEL = {
  urgent: { bg:"rgba(239,68,68,.15)", border:"rgba(239,68,68,.5)", color:"#ef4444", label:"🚨 URGENT" },
  warn:   { bg:"rgba(245,158,11,.12)", border:"rgba(245,158,11,.4)", color:"#f59e0b", label:"⚠️ WARN" },
  watch:  { bg:"rgba(6,182,212,.1)",   border:"rgba(6,182,212,.3)", color:"#06b6d4", label:"👀 WATCH" },
  normal: { bg:"transparent", border:"transparent", color:"#6b7280", label:"✅ 정상" },
};

function fmt(n) {
  if (!n && n!==0) return "—";
  if (n>=1e6) return `$${(n/1e6).toFixed(2)}M`;
  if (n>=1e3) return `$${(n/1e3).toFixed(1)}K`;
  return `$${n.toFixed(0)}`;
}

export default function TwapPanel({ data }) {
  if (!data) return <p style={{ color:"#6b7280" }}>HYPE 탭 선택 시 표시됩니다</p>;
  const level  = data.alert_level || "normal";
  const s      = LEVEL[level] || LEVEL.normal;
  const buyBig = data.buy_usd >= data.sell_usd;
  const br     = data.buy_ratio || 50;

  return (
    <div style={{ display:"flex",flexDirection:"column",gap:16 }}>
      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center" }}>
        <div style={{ padding:"6px 14px",borderRadius:8,background:s.bg,
          border:`1px solid ${s.border}`,color:s.color,fontWeight:700,fontSize:13 }}>
          {s.label}
        </div>
        <div style={{ textAlign:"right" }}>
          <p style={{ fontSize:11,color:"#6b7280" }}>HYPE 현재가</p>
          <p style={{ fontSize:22,fontWeight:700 }}>
            ${data.current_price?.toLocaleString("en-US",{minimumFractionDigits:4})}
          </p>
        </div>
      </div>

      <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:10 }}>
        <div style={{ padding:"12px 14px",borderRadius:10,
          background:buyBig?"rgba(34,197,94,.12)":"#181c24",
          border:`1px solid ${buyBig?"rgba(34,197,94,.35)":"#1e2433"}` }}>
          <p style={{ fontSize:11,color:"#6b7280",marginBottom:4 }}>🟢 Buy TWAP</p>
          <p style={{ fontSize:18,fontWeight:700,color:"#22c55e" }}>${data.buy_twap?.toFixed(4)}</p>
          <p style={{ fontSize:13,color:"#22c55e",fontWeight:600,marginTop:4 }}>{fmt(data.buy_usd)}</p>
        </div>
        <div style={{ padding:"12px 14px",borderRadius:10,
          background:!buyBig?"rgba(239,68,68,.12)":"#181c24",
          border:`1px solid ${!buyBig?"rgba(239,68,68,.35)":"#1e2433"}` }}>
          <p style={{ fontSize:11,color:"#6b7280",marginBottom:4 }}>🔴 Sell TWAP</p>
          <p style={{ fontSize:18,fontWeight:700,color:"#ef4444" }}>${data.sell_twap?.toFixed(4)}</p>
          <p style={{ fontSize:13,color:"#ef4444",fontWeight:600,marginTop:4 }}>{fmt(data.sell_usd)}</p>
        </div>
      </div>

      <div>
        <div style={{ display:"flex",justifyContent:"space-between",fontSize:11,color:"#6b7280",marginBottom:5 }}>
          <span>Buy {br.toFixed(1)}%</span>
          <span>전체 TWAP: ${data.total_twap?.toFixed(4)}</span>
          <span>Sell {data.sell_ratio?.toFixed(1)}%</span>
        </div>
        <div style={{ height:20,display:"flex",borderRadius:6,overflow:"hidden",background:"#1e2433" }}>
          <div style={{ width:`${br}%`,background:"#22c55e",display:"flex",alignItems:"center",
            justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff",transition:"width .5s" }}>
            {br>15?`${br.toFixed(1)}%`:""}
          </div>
          <div style={{ flex:1,background:"#ef4444",display:"flex",alignItems:"center",
            justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff" }}>
            {data.sell_ratio>15?`${data.sell_ratio?.toFixed(1)}%`:""}
          </div>
        </div>
      </div>

      <p style={{ fontSize:11,color:"#374151" }}>
        캔들 {data.candle_count}개 · {data.updated_at}
      </p>
    </div>
  );
}
